<div id="login-box" class="bg-emphasis rounded-lg p-5">
  @if (loadingInfo()) {
    <h2 class="text-2xl text-center">{{ 'general.login.title' | translate }}</h2>

    <div class="flex items-center h-full mt-8">
      <p-progress-spinner ariaLabel="loading" />
    </div>
  } @else {
    @if (error()) {
      <div class="flex flex-col items-center">
        <mat-icon [size]="100" color="var(--p-red-400)">error_outlined</mat-icon>
        <div class="mt-8 text-2xl text-red-400">{{ error() }}</div>
        <p-button class="mt-8" [outlined]="true" [label]="'general.back' | translate" (onClick)="goBack()" />
      </div>
    } @else {
      @if (api.isLoggedIn()) {
        <div class="h-full flex flex-col">
          @if (hasRequiredPermission()) {
            <span class="text-2xl font-bold mb-4 text-center">
              {{ 'oauth.consent.title' | translate }}
            </span>

            <span class="mb-4 text-center">
              {{ 'oauth.consent.text' | translate: { application: clientName } }}
            </span>
          } @else {
            <span class="text-2xl font-bold mb-4 text-center text-red-400">
              {{ 'oauth.denied.title' | translate }}
            </span>

            <span class="mb-4 text-center">
              {{ 'oauth.denied.text' | translate: { application: clientName } }}
            </span>
          }

          <div class="flex gap-4 items-center m-auto">
            <mat-icon [size]="32">person</mat-icon>
            <span class="text-xl">
              {{ api.user().username }}
            </span>
            <p-button [text]="true" severity="secondary" (onClick)="logout()" >
                <mat-icon>logout</mat-icon>
            </p-button>
          </div>

          @if (hasRequiredPermission()) {
            <div class="flex gap-8 justify-around mt-8">
              <p-button
                class="flex-1"
                fluid
                severity="danger"
                [label]="'oauth.consent.declineBtn' | translate"
                (onClick)="decline()"
              />
              <p-button
                class="flex-1"
                fluid
                severity="success"
                [label]="'oauth.consent.acceptBtn' | translate"
                (onClick)="accept()"
              />
            </div>
          } @else {
            <div class="mt-8">
              <p-button
                fluid
                [outlined]="true"
                [label]="'oauth.denied.backBtn' | translate"
                (onClick)="decline()"
              />
            </div>
          }
        </div>
      } @else {
        <p-fluid>
          <h2 class="text-2xl text-center">{{ 'general.login.title' | translate }}</h2>

          <form (submit)="login()" [formGroup]="loginForm">
            <p-floatlabel variant="on" class="mt-10">
              <input
                pInputText
                id="formfield-username"
                formControlName="username"
                autocomplete="off"
                required
              />
              <label for="formfield-username">{{ 'general.login.username' | translate }}</label>
            </p-floatlabel>

            <p-floatlabel variant="on" class="mt-5 mb-10">
              <p-password
                id="formfield-password"
                formControlName="password"
                [feedback]="false"
                autocomplete="off"
                required
              />
              <label for="formfield-password">{{ 'general.login.password' | translate }}</label>
            </p-floatlabel>

            @if (loginError()) {
              <p-message severity="error" class="mb-10">{{ loginError() | translate }}</p-message>
            }

            <p-button
              type="submit"
              [label]="'general.login.button' | translate"
              [disabled]="!loginForm.valid"
              [loading]="loggingIn()"
            />
            <!--!profileForm.valid-->
          </form>
        </p-fluid>
      }
    }
  }
</div>
